import { PDFImage, PDFTextField } from 'pdf-lib'

export const renderSignatureField = async (pdfField: PDFTextField, image: PDFImage) => {
  const [widget] = pdfField.acroField.getWidgets()
  widget.getOrCreateBorderStyle().setWidth(-1)

  pdfField.setImage(image)
  pdfField.enableReadOnly()
}
